import { render, staticRenderFns } from "./gcsccRank.vue?vue&type=template&id=0c83f70b&scoped=true&"
import script from "./gcsccRank.vue?vue&type=script&lang=js&"
export * from "./gcsccRank.vue?vue&type=script&lang=js&"
import style0 from "./gcsccRank.vue?vue&type=style&index=0&id=0c83f70b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c83f70b",
  null
  
)

export default component.exports